export default __webpack_public_path__ + "static/media/object-2.69e7a641.webp";